import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME, EXPORT_FILE_NAME } from './constants';


class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async GetWarehouse(Ids: any) {		
		return this.fetch(`/DropdownList/GetWarehouse/`, { workshopId: Ids });		
	}

	async GetFullStockValueMovementReport(DateFrom:any, DateTo:any, OrganizationId: any, LanguageId:any, WareHouseId:number|null, AllItems:boolean|false) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${API_NAME}/GetFullStockValueMovementReport?DateFrom=${DateFrom}&DateTo=${DateTo}${OrganizationId}&WareHouseId=${WareHouseId}&LanguageId=${LanguageId}&AllItems=${AllItems}`,EXPORT_FILE_NAME);
	}
}


export const apiProvider = new SestavyApi();
